import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import {
  getSingle,
  updateSingle,
  getStatuses,
} from "../../services/projectService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table } from "semantic-ui-react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import queryString from "query-string";

class RoomEditForm extends Form {
  state = {
    ref_date: new Date(),
    data: {
      company_name: "",
      project_name: "",
      mobile_tel: "",
      mobile_tel1: "",
      email: "",
      project_code: "",
      work_order: "",
      trn: "",
      status: "",
      consultant_name: "",
      consultant_email: "",
      consultant_phone1: "",
      consultant_phone2: "",
    },
    errors: {},
    statuses: [],
  };

  schema = {
    company_name: Joi.string().required().label("Company Name"),
    project_name: Joi.string().required().label("Project Name"),
    mobile_tel: Joi.string().required().label("Mobile/Tel"),
    mobile_tel1: Joi.allow("").label("Mobile/Tel2"),
    email: Joi.string().required().label("Email"),
    project_code: Joi.string().required().label("Project Code"),
    work_order: Joi.string().required().label("Work Order"),
    trn: Joi.string().required().label("TRN"),
    status: Joi.string().required().label("Status"),
    consultant_name: Joi.allow("").label("Name"),
    consultant_email: Joi.allow("").label("Email"),
    consultant_phone1: Joi.allow("").label("Mobile/Tel1"),
    consultant_phone2: Joi.allow("").label("Mobile/Tel2"),
  };

  handleChangeExpiry = (date) => {
    this.setState({
      ref_date: date,
    });
  };

  async populateAccount() {
    try {
      const accountId = this.props.match.params.id;
      this.setState({ blocking: true });
      const { data: account } = await getSingle(accountId);

      this.setState({ blocking: false });
      this.setState({ data: this.mapToViewModel(account) });

      const dateData = this.mapingData(account);

      this.setState({
        ref_date: new Date(dateData.ref_date),
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  mapingData(account) {
    return {
      ref_date: account.ref_date,
    };
  }

  async componentDidMount() {
    await this.populateAccount();
    const { data: res } = await getStatuses();

    this.setState({
      blocking: false,
      statuses: res.statuses,
    });
  }

  mapToViewModel(account) {
    return {
      company_name: account.company_name,
      project_name: account.project_name,
      mobile_tel: account.mobile_tel,
      mobile_tel1: account.mobile_tel1,
      email: account.email,
      project_code: account.project_code,
      work_order: account.work_order,
      trn: account.trn,
      status: account.status,
      consultant_name: account.consultant_name,
      consultant_email: account.consultant_email,
      consultant_phone1: account.consultant_phone1,
      consultant_phone2: account.consultant_phone2,
    };
  }

  doSubmit = async () => {
    try {
      const ledgerTypeId = this.props.match.params.id;

      const data = { ...this.state.data };
      data.id = parseInt(ledgerTypeId);
      this.setState({ blocking: true });

      // let formData = new FormData();
      // formData.append("room_number", this.state.data.room_number);
      // formData.append("name", this.state.data.name);
      // formData.append("mobile", this.state.data.mobile);
      // formData.append("rent", this.state.data.rent);

      let event = new Date(this.state.ref_date);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      //formData.append("expiry_date", date);
      // formData.append("_method", "PUT");

      data.ref_date = date;

      await updateSingle(data);
      this.setState({ blocking: false });
      toast.success("Account has been updated successfully.");
      this.props.history.push("/projects-accounts");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.company_name)
          errors.company_name = ex.response.data.errors.company_name;

        if (ex.response.data.errors.project_name)
          errors.project_name = ex.response.data.errors.project_name;

        if (ex.response.data.errors.mobile_tel)
          errors.mobile_tel = ex.response.data.errors.mobile_tel;

        if (ex.response.data.errors.email)
          errors.email = ex.response.data.errors.email;

        if (ex.response.data.errors.project_code)
          errors.project_code = ex.response.data.errors.project_code;

        if (ex.response.data.errors.work_order)
          errors.work_order = ex.response.data.errors.work_order;

        if (ex.response.data.errors.trn)
          errors.trn = ex.response.data.errors.trn;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  render() {
    // if (auth.getCurrentUser().email != "client-unblocker@gondalgroup.ae") {
    //   return "Your are authorized to perform this action.";
    // }
    const { keyword, status } = queryString.parse(this.props.location.search);

    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Update project</h1>

        <Link
          to={`/projects-accounts?keyword=${keyword}&status=${status}`}
          className="btn btn--secondary"
          style={{ marginBottom: "1rem", display: "inline-block" }}
        >
          Back
        </Link>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Update project</h3>
              <p>Provide the information below to update the project.</p>

              <p>
                <b>OWNER INFORMATION</b>
              </p>
              <div class="c_container">
                <div class="c_column">
                  <div class="c_field">
                    {this.renderInput(
                      "company_name",
                      "Client / Company Name",
                      "text"
                    )}
                  </div>
                  <div class="c_field">
                    {this.renderInput("mobile_tel", "Mobile/Tel1", "text")}
                  </div>
                </div>
                <div class="c_column">
                  <div class="c_field">
                    {this.renderInput("email", "Email", "text")}
                  </div>
                  <div class="c_field">
                    {this.renderInput("mobile_tel1", "Mobile/Tel2", "text")}
                  </div>
                </div>
              </div>

              <p>
                <b>CONSULTANT INFORMATION</b>
              </p>
              <div class="c_container">
                <div class="c_column">
                  <div class="c_field">
                    {this.renderInput("consultant_name", "Name", "text")}
                  </div>
                  <div class="c_field">
                    {this.renderInput(
                      "consultant_phone1",
                      "Mobile/Tel1",
                      "text"
                    )}
                  </div>
                </div>
                <div class="c_column">
                  <div class="c_field">
                    {this.renderInput("consultant_email", "Email", "text")}
                  </div>
                  <div class="c_field">
                    {this.renderInput(
                      "consultant_phone2",
                      "Mobile/Tel2",
                      "text"
                    )}
                  </div>
                </div>
              </div>

              <p>
                <b>PROJECT INFORMATION</b>
              </p>
              <div class="c_container">
                <div class="c_column">
                  <div class="c_field">
                    {this.renderInput("project_name", "Project Name", "text")}
                  </div>
                  <div class="c_field">
                    {this.renderInput("project_code", "Project Code", "text")}
                  </div>
                  <div class="c_field">
                    {this.renderInput("trn", "TRN", "text")}
                  </div>
                </div>
                <div class="c_column">
                  <div class="c_field">
                    {this.renderInput("work_order", "Work Order", "text")}
                  </div>
                  <div class="c_field">
                    <label>Ref Date</label>
                    <DatePicker
                      selected={this.state.ref_date}
                      onChange={this.handleChangeExpiry}
                      className="input"
                    />
                    <div class="c_field">
                      <label>&nbsp;</label>
                      {this.renderSelect(
                        "status",
                        "Select Status",
                        this.state.statuses
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* {this.renderInput(
                "company_name",
                "Client / Company Name",
                "text"
              )}
              {this.renderInput("project_name", "Project Name", "text")}
              {this.renderInput("mobile_tel", "Mobile/Tel", "text")}
              {this.renderInput("email", "Email", "text")}
              {this.renderInput("project_code", "Project Code", "text")}
              {this.renderInput("work_order", "Work Order", "text")}
              <label>Ref Date</label>
              <DatePicker
                selected={this.state.ref_date}
                onChange={this.handleChangeExpiry}
                className="input"
              />
              {this.renderInput("trn", "TRN", "text")}

              {this.renderSelect(
                "status",
                "Select Status",
                this.state.statuses
              )} */}

              {this.renderButton("Update")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default RoomEditForm;
